import request from './request'

export const getCommunityAgentCommunityList = (params) => {
  return request({
    url: '/admin/community-agent-communities',
    method: 'get',
    params
  })
}

export const createCommunityAgentCommunity = (data) => {
  return request({
    url: '/admin/community-agent-communities',
    method: 'post',
    data
  })
}

export const updateCommunityAgentCommunity = (id, data) => {
  return request({
    url: `/admin/community-agent-communities/${id}`,
    method: 'put',
    data
  })
}

export const deleteCommunityAgentCommunity = (id) => {
  return request({
    url: `/admin/community-agent-communities/${id}`,
    method: 'delete'
  })
}
